/*
 * Copyright (c) Airbus SAS. All rights reserved.
 */

/**
 * Open a `.modal` on connect when the server rendered an auto-open trigger for
 * it — e.g. after a redirect that should land with a modal already showing.
 *
 * The trigger is a hidden element carrying the usual `data-bs-toggle="modal"` /
 * `data-bs-target` / `data-frame-src` attributes, so clicking it reuses the
 * standard Bootstrap data-api + modal-template machinery (frame src, spinner,
 * reset on close) instead of re-implementing any of it here. Registered AFTER
 * modal-template so its `show.bs.modal` handler is attached before we click.
 *
 * @type {Listener}
 */
export default {
    selector: '[data-auto-open-modal]',
    connect(element) {
        element.click()
    },
}
